import {
  displayMatchTypes,
  fullTextMatchTypes,
  idAndNumericMatchTypes,
  idMatchTypes,
  skuMatchTypes,
  urlSlugMatchTypes,
} from '@/common/components/MatchTypeEditor/constants'

const mapToComboItems = (items = []) => items.map(item => ({ value: item.id, label: item.internal_name || item.name }))

export const getItemRequestTypeProperty = t => ({
  label: 'Tipo de solicitud',
  matchTypes: idMatchTypes,
  comboItems: [
    { value: 'refund', label: t('Devolución') },
    { value: 'variant_exchange', label: t('Cambio de variante', { context: 'item_request_type' }) },
    { value: 'other_product_exchange', label: t('Cambio por otro producto') },
  ],
})

export const getBaseProductProperties = ({ productTypes, productCategories, productCollections }) => ({
  product_name: { label: 'Nombre del producto', matchTypes: fullTextMatchTypes },
  product_external_id: {
    label: 'ID de producto',
    matchTypes: [...idAndNumericMatchTypes, displayMatchTypes.valueInRange],
  },
  sku: { label: 'SKU', matchTypes: skuMatchTypes },
  product_slug: { label: 'URL slug', matchTypes: urlSlugMatchTypes },
  product_type: {
    label: 'Tipo de producto',
    matchTypes: idMatchTypes,
    comboItems: mapToComboItems(productTypes),
  },
  product_category_id: {
    label: 'Categoría de producto',
    matchTypes: idMatchTypes,
    comboItems: mapToComboItems(productCategories),
  },
  product_collection_id: {
    label: 'Colección',
    matchTypes: idMatchTypes,
    comboItems: mapToComboItems(productCollections),
  },
  product_tag: { label: 'Etiqueta de producto', matchTypes: fullTextMatchTypes },
  product_variant_tag: { label: 'Etiqueta de variante', matchTypes: fullTextMatchTypes },
  custom_attributes: { label: 'Campos personalizados', matchTypes: fullTextMatchTypes },
  product_value: {
    label: 'Valor del producto',
    matchTypes: [
      displayMatchTypes.is,
      displayMatchTypes.isNot,
      displayMatchTypes.greaterThan,
      displayMatchTypes.greaterThanOrEqual,
      displayMatchTypes.lowerThan,
      displayMatchTypes.lowerThanOrEqual,
      displayMatchTypes.valueInRange,
    ],
  },
})

export const filterDisabledProperties = (conditionTypes, disabledConditionFields) => {
  Object.values(conditionTypes).forEach(condition => {
    disabledConditionFields.forEach(field => {
      delete condition.properties[field]
    })
  })

  return conditionTypes
}
